module.exports = {
	// __API_DOMAIN__:"",
	__API_DOMAIN__:"api.custody.cobo.com"
}